import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareFormSubmitRoute: InvariantJiraRoute = {
	name: 'software-form-submit',
	path: '/jira/software/projects/:projectKey/form/:formId',
	exact: true,
};
